import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { SuiEmptyStateComponent } from '@sui/empty-state';
import { PageLoadErrorService } from 'src/app/core/services/page-load-error.service';

/** The error state the app shell shows in place of a routed page whose load failed (WAP-1857). */
@Component({
  selector: 'app-page-load-error',
  templateUrl: './page-load-error.component.html',
  styleUrl: './page-load-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SuiEmptyStateComponent, TranslatePipe],
})
export class PageLoadErrorComponent {
  protected readonly message = inject(PageLoadErrorService).message;
}
